import { IHandleResponseError } from "@/Common/Api/IHandleResponseError";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";

/**
 * An error handler which applies Facturation.NET-specific response validation.
 */
class FacturationNetResponseError implements IHandleResponseError {
    /**
     * @inheritdoc
     */
    public handleError(response: ServerEvent): boolean {
        if (response && response.hasErrors && !isArrayNullOrUndefinedOrEmpty(response.Errors)) {
            let hasFacNetError = response.Errors.some(x => x.Code == "MustAskForUsernamePassword");

            if (hasFacNetError) {
                sessionStore.dispatchMain(LocalOperations.MainComponentViewOperations.DisplayFacturationNetUsernamePasswordPopup, { response: response });
                return false;
            }
        }

        return true;
    }
}

export { FacturationNetResponseError };
